module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_online-5b024f06b789715ed61c9371c17fcf86.jpg";